import React from 'react';
import { Star, Quote } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Avatar, AvatarFallback } from './ui/avatar';
import { testimonialsData } from '../data/mock';

const Testimonials = () => {
  return (
    <section id="testimonials" className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-4">
            {testimonialsData.title}
          </h2>
          <p className="text-xl text-slate-600">
            Don't just take our word for it - hear from our satisfied clients
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {testimonialsData.testimonials.map((testimonial, index) => (
            <Card
              key={testimonial.id}
              className="group hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border-slate-200 hover:border-cyan-300 bg-white relative overflow-hidden"
              style={{
                animationDelay: `${index * 100}ms`
              }}
            >
              {/* Quote Icon Background */}
              <div className="absolute top-6 right-6 opacity-5 group-hover:opacity-10 transition-opacity">
                <Quote className="w-20 h-20 text-red-600" />
              </div>

              <CardContent className="p-8 relative z-10">
                {/* Rating */}
                <div className="flex gap-1 mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="w-5 h-5 fill-amber-400 text-amber-400" />
                  ))}
                </div>

                {/* Feedback */}
                <p className="text-slate-700 leading-relaxed mb-6 text-lg italic">
                  "{testimonial.feedback}"
                </p>

                {/* Client Info */}
                <div className="flex items-center gap-4 pt-6 border-t border-slate-200">
                  <Avatar className="w-14 h-14 border-2 border-red-500">
                    <AvatarFallback className="bg-gradient-to-br from-red-600 to-red-700 text-white font-bold text-lg">
                      {testimonial.avatar}
                    </AvatarFallback>
                  </Avatar>
                  <div>
                    <div className="font-bold text-slate-900 text-lg">
                      {testimonial.name}
                    </div>
                    <div className="text-sm text-slate-600">
                      {testimonial.role}
                    </div>
                    <div className="text-sm font-semibold text-red-700">
                      {testimonial.company}
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Trust Badges */}
        <div className="mt-16 flex flex-wrap items-center justify-center gap-8 text-slate-600">
          <div className="flex items-center gap-2">
            <Star className="w-5 h-5 fill-amber-400 text-amber-400" />
            <span className="font-semibold">5.0 Average Rating</span>
          </div>
          <div className="hidden sm:block w-px h-6 bg-slate-300"></div>
          <div className="flex items-center gap-2">
            <span className="font-semibold">100+ Reviews</span>
          </div>
          <div className="hidden sm:block w-px h-6 bg-slate-300"></div>
          <div className="flex items-center gap-2">
            <span className="font-semibold">98% Satisfaction Rate</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
